<template>
    
    <article class="reservation-edit" v-if="booking">
        
        <div style="display: flex; flex-flow: row nowrap;">

            <div style="order: 2; margin-left: 2rem; margin-top: .5rem; width: 20rem;">
                <h2>Reserveret af</h2>
                <dl>
                    <dt>Email/brugernavn</dt>
                    <dd>
                        {{ booking.creator_details.email }}
                    </dd>
                    <dt>Navn</dt>
                    <dd>
                        {{ booking.creator_details.first_name }} {{ booking.creator_details.last_name }}
                    </dd>
                    <template v-if="booking.creator_details.guest">
                        <dt>Adresse</dt>
                        <dd>
                            {{ booking.creator_details.guest.address.street }} 
                            {{ booking.creator_details.guest.address.number }}
                            {{ booking.creator_details.guest.address.floor }}
                            {{ booking.creator_details.guest.address.door }}<br>
                            {{ booking.creator_details.guest.address.zipcode }}
                            {{ booking.creator_details.guest.address.town }}
                        </dd>
                        <dt>Telefonnr</dt>
                        <dd>
                            {{ booking.creator_details.guest.phone }}
                        </dd>
                    </template>
                </dl>
                <template v-if="locks">
                    <h2>Detaljer</h2>
                    <dl>
                        <dt>Dørlåskode til reservation</dt>
                        <dd>
                            <p v-for="l in locks" style="margin: 0;" :key="l.pk">
                                {{ l.code }}
                                <span class="emphasize">*</span>
                            </p>
                            <p class="muted">
                                Tast cifrene efterfulgt af stjerne (*)
                            </p>
                        </dd>
                    </dl>
                </template>
            </div>

            <div style="order: 1; margin-right: 2rem; width: 30rem;">

                <h1>Redigér reservation</h1>

                <div v-if="error" v-html="error"></div>

                <form @submit.prevent="saveBooking()">
                    <fieldset>
                        <label for="field-status">Status</label>
                        <select id="field-status" required v-model="booking.status">
                            <option value="0">Afventer godkendelse</option>
                            <option value="1">Godkendt</option>
                            <option value="2">Afvist</option>
                        </select>
                    </fieldset>
                    <fieldset>
                        <label for="field-title">Titel</label>
                        <input 
                            id="field-title" 
                            type="text" 
                            v-model="booking.title"
                            minlength="3"
                            title="Angiv en sigende titel">
                    </fieldset>
                    <fieldset>
                        <label for="field-resource">Lokale</label>
                        <select id="field-resource" required v-model="booking.resource">
                            <option v-for="r in resources" :key="r.id" :value="r.id">
                                {{ r.name }} | {{ r.admin_unit_name }}
                            </option>
                        </select>
                    </fieldset>
                    <edit-date-time :datetime="booking.start" label="Starter" @change="updateStartDate" />
                    <edit-date-time :datetime="booking.end" label="Slutter" @change="updateEndDate" />
                    <fieldset>
                        <label for="field-desc">Formål</label>
                        <textarea
                            style="height: 7rem;"
                            id="field-desc" 
                            placeholder="Hvad skal du bruge lokalet til?"
                            v-model="booking.description">
                        </textarea>
                    </fieldset>
                    <fieldset style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;">
                        <div>
                            <input type="submit" value="Gem">
                            <button type="button" @click="cancel()">Annullér</button>
                        </div>
                        <button type="button" @click="deleteBooking(booking.id)">Slet reservation</button>
                    </fieldset>
                </form>
            </div>

        </div>
            
    </article>

</template>

<script>

    import { dateJs2django, dateDjango2js } from '../../utils/Filters.js'
    import axios from '../../utils/Http.js'
    import notify from '../../utils/notify/Notify.js'
    import editDateTime from '../forms/EditDateTime.vue'

    export default {
        components: {
            editDateTime
        },
        data: function() {
            return {
                booking: null,
                locks: false,
                resource: null,
                resource_type: null,
                resource_approval_requirement: false,
                error: null,
                start_datetime: null,
                end_datetime: null
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            resources: function() {
                return this.$store.getters.getResourceList
            }
        },
        methods: {
            update: function() {
                if (!this.resources) {
                    this.$store.dispatch('fetchResources', '/booking/resource/')
                }
                this.fetchBooking()
            },
            updateStartDate: function(date) {
                this.start_datetime = date
            },
            updateEndDate: function(date) {
                this.end_datetime = date
            },
            fetchBookings: function() {
                const dj_now = encodeURIComponent(dateJs2django( new Date() )),
                    dj_future = encodeURIComponent(dateJs2django( new Date(new Date().getTime() + 315360000000) )),
                    options = `from=${ dj_now }&to=${ dj_future }`
                this.$store.dispatch('fetchBookings', options)
            },
            deleteBooking: function(id) {
                if (confirm('Vil du annullere denne reservation?')) {
                    this.$store.dispatch('deleteBooking', id)
                    .then(res => { 
                        this.fetchBookings()
                        this.$router.go(-1)
                    })
                }
            },
            fetchBooking: function() {
                axios({
                    method: 'get',
                    url: `/booking/booking/${ this.$route.params.id }/`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.fetchResourceInfo(res.data.resource)
                    this.booking = res.data
                    this.updateStartDate(res.data.start)
                    this.updateEndDate(res.data.end)
                    this.fetchLockInfo(res.data.id)
                })
                .catch(err => console.log(err))
            },
            fetchLockInfo: function(booking) {
                axios({
                    method: 'get',
                    url: `/locks/code/?booking__id=${ booking }`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    if (res.data.length > 0) {
                        this.locks = res.data
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            },
            fetchResourceInfo: function(res_id) {
                axios({
                    method: 'get',
                    url: `/booking/resource/${ res_id }/`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.fetcResourceTypeInfo(res.data.resource_type)
                    this.resource = res.data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            fetcResourceTypeInfo: function(res_typ_id) {
                axios({
                    method: 'get',
                    url: `/booking/resourcetype/${ res_typ_id }/`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.resource_type = res.data
                    if (!this.user.is_staff) {
                        let approval_limit = this.resource_type.limitations.borger.find(function(e) {
                            return e.type === 'approvalrequirement'
                        })
                        if (approval_limit) {
                            this.resource_approval_requirement = true
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            },
            saveBooking: function() {
                
                this.error = null

                // Check if start and end dates don't require time travel
                let start = dateDjango2js(this.start_datetime).getTime(),
                    end = dateDjango2js(this.end_datetime).getTime()
                if (start >= end) {
                    this.error = '<p class="form-error error">Start-tidspunktet skal være før slut-tidspunktet</p>'
                    return false
                }
                
                let data = {
                    title: this.booking.title,
                    description: this.booking.description,
                    resource: this.booking.resource,
                    start: this.start_datetime,
                    end: this.end_datetime,
                    status: this.booking.status
                }

                axios({
                    method: 'patch',
                    url: `/booking/booking/${ this.$route.params.id }/`,
                    data: data,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.fetchBookings()
                    notify('Reservationen er ændret', 'success')
                    this.$router.go(-1)
                })
                .catch(err => {
                    if (err.response.data) {
                        this.error = ''
                        for (let d in err.response.data.detail) {
                            for (let d2 in err.response.data.detail[d]) {
                                this.error += `<p class="form-error error">${ err.response.data.detail[d][d2] }</p>`
                            }
                        }
                    } else {
                        this.error = err
                    }
                    notify('Reservationen kunne ikke ændres', 'error')
                })

            },
            cancel: function() {
                this.$router.go(-1)
            }
        },
        created: function() {
            this.update()
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .reservation-edit {
        padding: 1rem;
    }

</style>
